import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class FileDownloadService {

    public baseURL = environment.apiUrl;

    constructor(private http: HttpClient) {
    }

    public download(baseURI: any): void {
        const url = `${this.baseURL}${baseURI}`;
        this.http.get(url, { observe: 'response', responseType: 'blob' as 'json' } ).subscribe(
            (res) => {
              const hrefUrl = window.URL.createObjectURL(res.body as Blob);
                const anchor = document.createElement('a');
                let attachment: string = res.headers.get('content-disposition') || '';
                if (attachment.includes('filename=')) {
                    anchor.download = attachment.split('filename=')[1]?.trim() ? res.headers.get('content-disposition')!.split('filename=')[1]?.trim() : 'file.pdf';
                } else {
                    anchor.download = attachment.split('fileName=')[1]?.trim() ? res.headers.get('content-disposition')!.split('fileName=')[1]?.trim() : 'file.pdf';
                }
                anchor.download = anchor.download?.replace(/['"]+/g, '');
                anchor.href = hrefUrl;
                anchor.click();
            }
        );

    }
    
}
